import React from 'react';
import { Link } from 'react-router-dom';

interface TaskStats {
  q1: number;
  q2: number;
  q3: number;
  q4: number;
  total: number;
}

interface TasksOverviewCardProps {
  stats: TaskStats;
  loading?: boolean;
  error?: string | null;
}

function TasksOverviewCard({ stats, loading, error }: TasksOverviewCardProps) {
  if (loading) {
    return (
      <div className="card">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Tasks</h3>
          <div className="animate-pulse bg-mc-border h-4 w-12 rounded"></div>
        </div>
        <div className="animate-pulse bg-mc-border h-10 w-16 rounded mb-2"></div>
        <div className="animate-pulse bg-mc-border h-4 w-20 rounded"></div>
        <div className="grid grid-cols-2 gap-2 mt-4 pt-4 border-t border-mc-border">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="animate-pulse bg-mc-border h-4 w-16 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">Tasks</h3>
        <Link to="/tasks" className="text-mc-accent text-sm hover:underline">
          View all
        </Link>
      </div>

      <div className="text-4xl font-bold text-mc-accent">{stats.total}</div>
      <p className="text-mc-muted text-sm mt-2">
        {error ? (
          <span className="text-mc-warning">{error}</span>
        ) : (
          'Open tasks'
        )}
      </p>

      {/* Eisenhower Matrix Summary */}
      <div className="grid grid-cols-2 gap-2 mt-4 pt-4 border-t border-mc-border">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded bg-mc-danger"></span>
          <span className="text-sm">Q1: {stats.q1}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded bg-mc-accent"></span>
          <span className="text-sm">Q2: {stats.q2}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded bg-mc-warning"></span>
          <span className="text-sm">Q3: {stats.q3}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded bg-mc-muted"></span>
          <span className="text-sm">Q4: {stats.q4}</span>
        </div>
      </div>
    </div>
  );
}

export default TasksOverviewCard;
